<template>
    <a-modal :visible="isShow" width="960px" :title="title" :footer="null" @cancel="cancel" class="address_modal">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr height="50" bgcolor="#fafafa" align="center">
                <td><b>商品</b></td>
                <td width="150"><b>编辑数量</b></td>
            </tr>
        </table>
        <div class="goods_list">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tr height="90" v-for="goods in goodsList" :key="'depot_modal_'+goods.id">
                    <td width="90"><img :src="goods.goods_image" width="80" height="80" /></td>
                    <td valign="top" class="goods_name">
                        <p><a :href="'https://detail.91jf.com/goods/'+goods.encode_id" target="_blank">{{goods.goods_name}} {{goods.spec_name}}</a></p>
                        <p>
                            <span class="goods_tips">{{getSendStatusName(goods.send_status)}}</span>
                            <span class="goods_tips" v-if="goods.refund_state > 0">{{getRefundStatusName(goods.refund_state)}}</span>
                            <span class="goods_tips" v-if="goods.order_id > 0">已转订单</span>
                        </p>
                        <p v-if="goods.order_id > 0">订单编号：{{goods.order_sn}}</p>
                    </td>
                    <td width="150" align="center">
                        <input-number :num="goods.num" :max="goods.num" tip="分拆不允许小于1或超过最大数量" @changeCartNum="changeNum($event,goods.id)"></input-number>
                    </td>
                </tr>
            </table>
        </div>
        <div class="btn_confirm">
            <a-button type="primary" @click="ok">{{buttonText}}</a-button>
            <a-button @click="cancel">取消</a-button>
        </div>
    </a-modal>
</template>

<script>
import InputNumber from '@/components/common/InputNumber.vue'

export default {
    name: 'DepotModal',
    props: ['type','data'],
    components: {
        InputNumber
    },
    data () {
        return {
            title: '加入采购车',
            goodsList: [],
            isShow: false,
            buttonText: '确认加购'
        }
    },
    watch: {
        type: {
            handler (val) {
                this.title = val == 'cart' ? '加入采购车' : '转为订单';
                this.buttonText = val == 'cart' ? '确认加购' : '确认转订单';
            },
            immediate: true
        },
        data: {
            handler (val) {
                this.goodsList = val;
            },
            deep: true,
            immediate: true
        },
    },
    created () {

    },
    methods: {
        ok(){
            if(this.type == 'order'){
                var ids = [];
                var data = this.data;

                for(var i = 0; i < data.length; i++){
                    ids.push(data[i].id);
                }
                console.log(ids)
                this.$router.push({
                    path: '/ordering',
                    query: {
                        type: 'depot',
                        ids: ids.join(',')
                    }
                });
            }else{
                var req = [];
                var _this = this;

                for(var i = 0; i < _this.goodsList.length; i++){
                    req.push({
                        id: _this.goodsList[i].id,
                        num: _this.goodsList[i].num
                    });
                }

                _this.$util.api('/depot/cart',{
                    data: JSON.stringify(req)
                },function(res){
                    _this.$message[res.code == 10000 ? 'success' : 'error'](res.msg);

                    if(res.code == 10000){
                        _this.cancel();
                        _this.$emit('ok');
                    }
                });
            }
        },
        changeNum(num,id){
            for(var i = 0; i < this.goodsList.length; i++){
                if(this.goodsList[i].id == id){
                    this.goodsList[i].num = num;
                }
            }
        },
        cancel () {
            this.isShow = false;
        },
        getSendStatusName(status){
            var res = '未取货';

            if(status == 1){
                res = '已取货';
            }else if(status == 2){
                res = '已入库';
            }

            return res;
        },
    },
}
</script>

<style scoped>
.address_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}

.address_modal >>> .ant-form-item:nth-child(n + 2) {
    margin-bottom: 0;
    margin-top: 35px;
}
.btn_confirm {
    text-align: center;
    margin-top: 20px;
}
.btn_confirm >>> .ant-btn {
    padding: 0 22px;
    height:30px;
}
.goods_name{
    line-height:25px;
}
.goods_name a{
    color:#333;
}
.goods_name a:hover{
    color:#fd5902;
}
.goods_tips{
    color:#333;
    background:#d8d8d8;
    display:inline-block;
    height:20px;
    line-height:20px;
    font-size:12px;
    padding:0 5px;
    margin-right:5px;
}
.goods_list{
    max-height:360px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/deal/depot/DepotModal.vue